export enum CardOrder {
    alternating = 1,
    ranksuit = 2,
}

export enum MoveTrumps {
    none = 'none', dummy = 'dummy', all = 'all'
}

export enum CardFace {
    classic, modern
}

export enum BiddingBoxKind {
    normal, compact
}

export enum PlayBy {
    dragging = 'dragging',
    clicking = 'clicking',
    dblClicking = 'dbl-clicking',
}

export const DefinesClient = {
    FONT_SIZE: 14.0,

    // The layout is designed for at least this much room, in CSS pixels. Below it the
    // table cannot be drawn at its intended size and autozoom starts scaling down.
    CLIENT_MIN_WIDTH: 1024,
    CLIENT_MIN_HEIGHT: 620,

    CARD_SPACING_DEFAULT: 15,
    CARD_SPACING_MIN: 10,
    CARD_SPACING_MAX: 30,

    TIMEOUT_TRICK_SHOWN: 3000, // ms
    TIMEOUT_PLAY_GUARD: 700, // ms, minimum time between two card plays from the same hand
    PLAYERS_INACTIVE_TIME_SEC: 2 * 60,
} as const